import profileImg from "../components/img/self.jpeg";
import davinciIcon from "../components/img/icons/1024px-DaVinci_Resolve_Studio.png";
import photoshopIcon from "../components/img/icons/photoshop.png";
import lightroomIcon from "../components/img/icons/photoshop-lightroom.png";
import premiereIcon from "../components/img/icons/premiere-pro.png";
import afterEffectsIcon from "../components/img/icons/after-effects.png";
import auditionIcon from "../components/img/icons/adobe-audition.png";
import figmaIcon from "../components/img/icons/figma.png";
import captureOneIcon from "../components/img/icons/Capture_One_New_Logo_.png";
import JavaScriptIcon from "../components/img/icons/Javascript_Logo.png";
import TypeScriptIcon from "../components/img/icons/Typescript_logo_2020.png";
import ReactIcon from "../components/img/icons/programing.png";
import PythonIcon from "../components/img/icons/Python-logo-notext.png";
import HTMLCSSIcon from "../components/img/icons/html.png";
import NodeJSIcon from "../components/img/icons/Node.js_logo.png";
import CSharpIcon from "../components/img/icons/C_Sharp_Icon.png";
import PHPIcon from "../components/img/icons/PHP-logo.png";
// Placeholder profile data
export const profileData = {
  name: "Phillipus Van der Hoven",
  title: "Photographer & Full Stack Developer",
  bio: "I am a photographer and full-stack developer working at the intersection of creativity and logic. My visual work spans the scale of expansive landscapes, the high-speed precision of Formula Vee racing, and the raw textures of industrial design. On the technical side, I build integrated web and app solutions, leveraging AI and custom Python automation to bridge the gap between aesthetic vision and functional innovation.",
  email: "Phillipvdh@steelbladephotography.com",
  github: "https://github.com/PHILLIP8264",
  linkedin: "https://www.linkedin.com/in/phillip-van-der-hoven-696818338",
  profileImage: profileImg,
};

// Software proficiency
export const softwareProficiency = [
  { name: "Adobe Photoshop", icon: photoshopIcon },
  { name: "Adobe Lightroom", icon: lightroomIcon },
  { name: "Adobe Premiere Pro", icon: premiereIcon },
  { name: "Adobe After Effects", icon: afterEffectsIcon },
  { name: "Adobe Audition", icon: auditionIcon },
  { name: "DaVici Resolve", icon: davinciIcon },
  { name: "Figma", icon: figmaIcon },
  { name: "Capture One", icon: captureOneIcon },
];

// Programming languages
export const programmingLanguages = [
  { name: "JavaScript", icon: JavaScriptIcon },
  { name: "TypeScript", icon: TypeScriptIcon },
  { name: "React", icon: ReactIcon },
  { name: "Python", icon: PythonIcon },
  { name: "HTML & CSS", icon: HTMLCSSIcon },
  { name: "Node.js", icon: NodeJSIcon },
  { name: "C#", icon: CSharpIcon },
  { name: "PHP", icon: PHPIcon },
];
